/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ccc49d768b8a735f2f56bb807595c00e495bcafd";
